import { get } from './methods';

interface AssembleiaConvocado {
  dataEvento: string;
  titulo: string;
}

export type AssembleiasConvocado = Array<AssembleiaConvocado>;

export default {
  assembleias: (cpfCnpj: string) => {
    const endpoint = `convocado/${cpfCnpj}`;
    return get<AssembleiasConvocado>(endpoint);
  },
  convocacoes: (idAssembleia: number) => {
    const endpoint = `convocado/convocacoes/${idAssembleia}`;
    return get<number>(endpoint);
  },
};
